import { api, apiMipe } from '@/core/api/';

import ServiceTypeCategories from '@/utils/constants/serviceTypeCategories.js';
import disciplineCategories from '@/utils/constants/disciplineCategories';

export const getProviderDetail = (providerId) => {
  return api.get(`/api/providers/detail/${providerId}`);
};

export const searchProviders = async ({
  firstLoad,
  isActive,
  nameSsn,
  page,
  companyId,
  companyTypeId,
  desc,
}) => {
  try {
    const { data } = await api.get('/api/providers/list/contractpropolsal', {
      params: {
        nameSsn,
        firstLoad,
        isActive,
        page,
        companyId,
        companyTypeId,
        desc,
      },
    });
    return data;
  } catch {
    return null;
  }
};
export const providersFilterList = async () => {
  try {
    const { data } = await api.get('/api/providers/list/contractpropolsalall');
    return data;
  } catch {
    return null;
  }
};

export const getStatuses = async () => {
  try {
    const { data } = await api.get('/api/providers/proposal/statuses', {});
    return data;
  } catch {
    return [];
  }
};

export const getYears = async () => {
  try {
    const { data } = await apiMipe.get('/api/academicyears');
    return data.map(({ id, description, selected }) => ({
      id,
      name: description,
      selected,
    }));
  } catch {
    return null;
  }
};

export const getCurrentAcademicYear = async () => {
  try {
    const { data } = await apiMipe.get('/api/academicyears/current');
    data.name = data.description; //set missing name prop
    return data;
  } catch {
    return null;
  }
};

export const getAcademicYears = async () => {
  return api.get('/api/providers/proposal/academicyears');
};

export const getAdminFilters = async (academicYear) => {
  let responseObject = {};
  await api
    .get('/api/providers/proposal/academicyears')
    .then((response) => {
      responseObject.AcademicYear = response.data;
      return api.get('/api/providers/proposal/area');
    })
    .then((response) => {
      responseObject.Area = response.data;
      if (academicYear) {
        return api.get(`/api/providers/proposal/evaluators/${academicYear}`);
      }
    })
    .then((response) => {
      responseObject.Evaluators = response.data;
      return api.get('/api/providers/proposal/companies');
    })
    .then((response) => {
      responseObject.Companies = response.data;
      return api.get('/api/providers/proposal/statuses');
    })
    .then((response) => {
      responseObject.Statuses = response.data;
    })
    .catch(({ errors }) => {
      return errors;
    });

  return responseObject;
};

export const getProposalService = async (filters) => {
  return await api.post('/api/providers/proposal/proposalrequests', filters);
};

export const hasEvaluatorAccess = async () => {
  try {
    const { data } = await api.get('/api/providers/proposal/isevaluator', {});
    return data;
  } catch {
    return false;
  }
};

export const getMunicipalities = async () => {
  try {
    const { data } = await apiMipe.get('api/schools/municipalities');
    return data;
  } catch {
    return [];
  }
};

export const getCompanyMunicipalities = async ({
  fiscalYearId,
  companyId,
  locationTypeId,
}) => {
  try {
    const { data } = await api.get('api/servicelocations/municipalities', {
      params: {
        fiscalYearId: fiscalYearId,
        companyId: companyId,
        locationTypeId: locationTypeId,
      },
    });
    return data;
  } catch {
    return [];
  }
};

export const save = async (model) => {
  try {
    const rupNumber = parseInt(model.generalInfoForm.rupNumber);
    const profitType = parseInt(model.generalInfoForm.profitType);
    const stateDeptRegistration = parseInt(
      model.generalInfoForm.stateDeptRegistration
    );

    const provider = {
      id: 0,
      companyId: 0,
      name: '',
      ssn: '',
      status: '',
      fiscalYear: '',
      fiscalYearId: 0,
      locationFiscalYearId: 0,
      organization: null,
      proposalNumber: model.proposalNumber,
      company: {
        id: 0,
        rupNumber: isNaN(rupNumber) ? null : rupNumber,
        profitType: isNaN(profitType) ? null : profitType,
        specialty: model.generalInfoForm.specialty,
        licenseNumber: model.generalInfoForm.licenseNumber,
        stateDeptRegistration: isNaN(stateDeptRegistration)
          ? null
          : stateDeptRegistration,
        name: model.generalInfoForm.name,
        organizationId: null,
        companyTypeCd: model.generalInfoForm.type.id,
        nameFirst: model.primaryContactForm.name,
        nameLastMaternal: model.primaryContactForm.motherLastName,
        nameLastPaternal: model.primaryContactForm.lastName,
        isServiceAssistant: false,
        isServiceRequestCompany: false,
        isMainCompany: model.isMainCompany,
        isIncorporatedCompany: false,
        socialSecurityNo: model.ssn,
        parentMainCompanyId: model.parentMainCompanyId,
        deleteFlag: '0',
        cifras: [],
      },
      location: {
        locationId: 0,
        locationName: '',
        locationSchoolId: null,
        centerId: null,
        locationTelephoneNo: model.generalInfoForm.phone,
        locationTelephoneFaxNo: model.generalInfoForm.fax,
        locationTypeId: 0,
        locationWebsiteUrl: model.generalInfoForm.website,
      },
      address: {
        addressId: 0,
        addressDescription: model.physicalAddressForm.annotations,
        addressLine1: model.physicalAddressForm.addressOne,
        addressLine2: model.physicalAddressForm.addressTwo,
        addressLine3: model.physicalAddressForm.addressThree,
        addressName: '',
        addressTypeCd: 1,
        municipalityId: model.physicalAddressForm.municipality.id,
        gpsLatitude: null,
        gpsLongitude: null,
        zipCode: model.physicalAddressForm.zipCode,
      },
      contact: {
        id: 0,
        email: model.primaryContactForm.email,
        nameFirst: model.primaryContactForm.name,
        nameInitial: model.primaryContactForm.initial,
        nameLastMaternal: model.primaryContactForm.motherLastName,
        nameLastPaternal: model.primaryContactForm.lastName,
        telephoneHomeFaxNo: model.primaryContactForm.fax,
        telephoneHomeNo: '',
        telephoneMobileNo: model.primaryContactForm.phone,
        telephoneWorkFaxNo: '',
        telephoneWorkNo: model.primaryContactForm.workPhone,
        telephoneWorkExtNo: '',
        websiteURL: model.generalInfoForm.website,
        workDepartmentName: model.primaryContactForm.department,
        workPositionTitle: model.primaryContactForm.position,
        deleteFlag: '0',
        municipality: model.primaryContactForm.municipality,
        civilStatusId: parseInt(model.primaryContactForm.civilStatusId),
      },
    };

    const { data } = await api.post('/api/providers/save', provider);

    return data;
  } catch (error) {
    return error.message;
  }
};

export const edit = async (model) => {
  return await api.post('/api/providers/edit', model);
};

export const editHeaderInfo = async (model) => {
  return await api.post('/api/providers/editHeaderInfo', model);
};

export const getCivilStatuses = async () => {
  return await api.get('/api/servicelocations/civilstatuses');
};

export const createContact = async (model) => {
  return await api.put('/api/servicelocations/contact', model);
};

export const editContact = async (model) => {
  return await api.post('/api/servicelocations/contact', model);
};

export const deleteContact = async (contactId) => {
  return await api.delete(`/api/servicelocations/contact/${contactId}`);
};

export const createAddress = async (model) => {
  return await api.put('/api/servicelocations/address', model);
};

export const editAddress = async (model) => {
  return await api.post('/api/servicelocations/address', model);
};

export const deleteAddress = async (addressId) => {
  return await api.delete(`/api/servicelocations/address/${addressId}`);
};

export const createContractService = async (contractId, model) => {
  return await api.put(`/api/providers/contract/service/${contractId}`, model);
};

export const saveNationalIdentifier = async (
  id,
  nationalIdentifier,
  medicalIdentifier
) => {
  return await api.patch(`/api/providers/company/${id}/nationalIdentifier`, {
    nationalIdentifier,
    medicalIdentifier,
  });
};

export const saveMedicaidEligibility = async (id, payload) => {
  return await api.post(`/api/providers/company/${id}/eligibility`, payload);
};

export const deleteContractServices = async (model) => {
  return await api.post(`/api/providers/contract/services/delete`, model);
};

export const editContractService = async (model) => {
  return await api.post('/api/providers/contract/service', model);
};

export const updateContractServicesPrice = async (model) => {
  return await api.post('/api/providers/contract/services', model);
};

export const deleteContractService = async (serviceId) => {
  return await api.delete(`/api/providers/contract/service/${serviceId}`);
};

export const getAddressTypes = async () => {
  return await apiMipe.get(`/api/code/addresstypes`);
};

export const getContractServices = async (contractId, companyId) => {
  return await api.get('/api/providers/contract/services', {
    params: { contractId: contractId, companyId: companyId },
  });
};

export const signContract = (contractId) => {
  return api.post(`/api/providers/contract/sign/${contractId}`);
};

export const getSpecialistServiceTypes = async () => {
  return await api.get('/api/providers/specialists/services');
};

export const getSpecialistServices = async (serviceTypeId) => {
  return await api.get(
    `/api/providers/specialists/disciplines/${serviceTypeId}`
  );
};

export const getSpecialistAgeRange = async () => {
  return await api.get('/api/providers/specialists/agerange');
};
//ECG:Esto no parece ir aqui ...
export const getCompanyLocationsCurrentYear = async (
  locationTypeId,
  companyId
) => {
  return await api.get(
    `/api/providers/specialists/servicelocations/${locationTypeId}/${companyId}`
  );
};

export const getCompanyTypes = async () => {
  try {
    const { data } = await apiMipe.get('api/code/companyTypes');
    return data;
  } catch {
    return [];
  }
};

export const validateSsn = async (ssn) => {
  try {
    const { data } = await api.get(`/api/providers/validate/${ssn}`);
    return data;
  } catch {
    return false;
  }
};

export const proposalsCanBeAssignedToEvaluators = async () => {
  return await api.get('/api/providers/proposal/evaluator/canbeassigned');
};

export const validateProposalsAssignedToEvaluators = () => {
  return api.get('/api/providers/proposal/evaluator/assign/validate');
};

export const previewProposalsAssignedToEvaluators = async () => {
  return await api.get('/api/providers/proposal/evaluator/assign/preview');
};

export const getServiceLocationTypes = async () => {
  return await api.get('/api/servicelocations/types');
};

export const getServiceTypes = async () => {
  return await apiMipe.get(`api/code/servicetypes`);
};

export const getContractServiceTypes = async () => {
  return await apiMipe.get(
    `api/code/servicetypes?categoryId=${ServiceTypeCategories.ContractService}`
  );
};

export const getServiceLocationServiceTypes = async () => {
  return await apiMipe.get(
    `api/code/servicetypes?categoryId=${ServiceTypeCategories.ServiceLocation}`
  );
};

export const getCodeServiceTypes = (categoryId) => {
  return apiMipe.get('/api/code/servicetypes', {
    params: {
      categoryId,
    },
  });
};

export const getServicePlaces = (params) => {
  return api.get('/api/servicelocations/specialists/list', {
    params,
  });
};

export const getSpecialists = (params) => {
  return api.get('/api/providers/specialists', { params });
};

export const getSpecialistBySSN = (ssn, companyId) => {
  return api.get(`/api/providers/specialists/${ssn}/${companyId}/info`);
};

export const getSpecialistBySsnOrHdn = (ssnOrHdn, companyId) => {
  return api.get(`/api/providers/specialists/${ssnOrHdn}/${companyId}/info`, {
    params: { hdn: ssnOrHdn },
  });
};

export const getSpecialistByUser = (userId) => {
  return api.get(`/api/providers/specialists/${userId}/infobyuser`);
};

export const getTypePlaces = () => {
  return apiMipe.get('api/code/locationtypes/8');
};

export const getSpecialistYears = () => {
  return apiMipe.get('api/academicyears/specialists');
};

export const getServiceModalities = async (payload) => {
  if (payload) {
    return await apiMipe.get('api/code/servicemodalities', {
      params: {
        ...payload,
      },
    });
  } else {
    return await apiMipe.get('api/code/servicemodalities');
  }
};

export const getTherapyDurations = async (payload) => {
  if (payload) {
    return await apiMipe.get('api/code/therapydurations', {
      params: {
        ...payload,
      },
    });
  } else {
    return await apiMipe.get('api/code/therapydurations');
  }
};

export const getServices = async (serviceTypeIds, categories) => {
  let qs = '';

  if (serviceTypeIds != undefined && serviceTypeIds != null) {
    for (let i = 0; i < serviceTypeIds.length; i++) {
      qs += `serviceTypeIds=${serviceTypeIds[i]}&`;
    }
  }

  if (categories != undefined && categories != null) {
    for (let i = 0; i < categories.length; i++) {
      qs += `categories=${categories[i]}&`;
    }
  }

  if (qs.length > 0) qs = qs.slice(0, -1);

  // In MIPE DB the "discipline types" are in fact the "services"
  return await apiMipe.get(`api/code/disciplinetypes?${qs}`);
};

export const getServicesProv = async (serviceTypeIds) => {
  let qs = '';

  if (serviceTypeIds != undefined && serviceTypeIds != null) {
    for (let i = 0; i < serviceTypeIds.length; i++) {
      qs += `serviceTypeIds=${serviceTypeIds[i]}&`;
    }
  }

  qs += `categories=${disciplineCategories.ValidForTherapy}&categories=${disciplineCategories.ValidForPEI}&`;

  if (qs.length > 0) qs = qs.slice(0, -1);

  // In MIPE DB the "discipline types" are in fact the "services"
  return await api.get(`api/code/disciplinetypes?${qs}`);
};

export const getTherapyServices = async (serviceTypeIds, categories) => {
  let qs = '';

  if (serviceTypeIds != undefined && serviceTypeIds != null) {
    for (let i = 0; i < serviceTypeIds.length; i++) {
      qs += `serviceTypeIds=${serviceTypeIds[i]}&`;
    }
  }

  if (categories != undefined && categories != null) {
    for (let i = 0; i < categories.length; i++) {
      qs += `categories=${categories[i]}&`;
    }
  }

  qs += `categories=${disciplineCategories.ValidForTherapy}&`;

  if (qs.length > 0) qs = qs.slice(0, -1);

  // In MIPE DB the "discipline types" are in fact the "services"
  return await apiMipe.get(`api/code/disciplinetypes?${qs}`);
};

export const searchServiceLocations = async ({
  fiscalYearId,
  type,
  providerId,
  locationId,
  municipalityId,
  serviceTypeCode,
  activeStatus,
  page,
}) => {
  try {
    const { data } = await api.get('/api/servicelocations', {
      params: {
        fiscalYearId,
        providerId,
        type,
        locationId,
        municipalityId,
        serviceTypeCode,
        activeStatus,
        page,
      },
    });
    return data;
  } catch {
    return null;
  }
};

export const providersList = async ({ fiscalYearId }) => {
  try {
    const { data } = await api.get('/api/providers/list', {
      params: { fiscalYearId },
    });
    return data;
  } catch {
    return null;
  }
};

export const getlocationservicecompany = async ({
  fiscalYearId,
  companyId,
}) => {
  try {
    const { data } = await api.get(
      `/api/servicelocations/company/${fiscalYearId}/${companyId}`
    );
    return data;
  } catch {
    return null;
  }
};

export const getExcludedDisciplineTypes = async (locationFiscalYearId) =>
  await api.get(
    `/api/servicelocations/excludeddisciplinetypes/${locationFiscalYearId}`
  );

export const updateExcludedDisciplineTypes = async (model) =>
  await api.put(
    `api/servicelocations/updateexcludeddisciplinetypesbylocation`,
    model
  );

export const getlocationservicedetail = async ({ locationFiscalYearId }) => {
  try {
    const { data } = await api.get(
      `/api/servicelocations/detail/${locationFiscalYearId}`
    );
    return data;
  } catch {
    return null;
  }
};

export const updateGeneralInfo = (model) => {
  return api.put('/api/servicelocations/generalinformation', model);
};

export const insertservicelocation = async (model) => {
  return await api.put('/api/servicelocations/', model);
};

export const getCaats = async () => {
  try {
    const { data } = await apiMipe.get('api/caats/getallcaats');
    return data;
  } catch {
    return [];
  }
};

export const getCaatsMunicipalities = async ({ id }) => {
  try {
    const { data } = await apiMipe.get('api/caats/municipalities', {
      params: { id },
    });
    return data;
  } catch {
    return [];
  }
};

export const insertServiceLocationAddress = async (model) => {
  return await api.put('api/servicelocations/address', model);
};

export const deleteServiceLocationAddress = async (addressId) => {
  return await api.delete(`api/servicelocations/address/${addressId}`);
};

export const updateServiceLocationAddress = async (model) => {
  return await api.post('api/servicelocations/address', model);
};

export const insertServiceLocationContact = async (model) => {
  return await api.put('api/servicelocations/contact', model);
};

export const deleteServiceLocationContact = async (contactId) => {
  return await api.delete(`api/servicelocations/contact/${contactId}`);
};

export const updateServiceLocationContact = async (model) => {
  return await api.post('api/servicelocations/contact', model);
};
export const getContracts = async ({ companyId, fiscalYearId }) => {
  return await api.get('api/providers/contract', {
    params: { companyId: companyId, fiscalYearId: fiscalYearId },
  });
};

export const getContract = async (contractId) => {
  return await api.get(`api/providers/contract/detail/${contractId}`);
};

export const insertContractService = async (model) => {
  return await api.put('api/providers/contract/save', model);
};

export const getPurchaseOrderList = async () => {
  return await api.get('api/providers/contract/purchaseordernumber/list');
};

export const insertContract = async (model) => {
  return await api.post('api/providers/contract', model);
};

export const updateContract = async (model) => {
  return await api.put('api/providers/contract', model);
};

export const uploadContractDocument = (contractId, params) => {
  return api.post(`api/providers/contract/${contractId}/documents`, params, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const getContractDocuments = (contractId) => {
  return api.get(`api/providers/contract/${contractId}/documents`);
};

export const updateContractNumber = (contractId, contractNumber) => {
  return api.put(
    `api/providers/contract/${contractId}/updatecontractnumber?contractNumber=${contractNumber}`
  );
};

export const updateContractNumberAndFinancialSystem = (
  contractId,
  contractNumber,
  contractNumberFinancialSystem
) => {
  return api.put(
    `api/providers/contract/${contractId}/updatecontractnumber?contractNumber=${contractNumber}&contractNumberFinancialSystem=${contractNumberFinancialSystem}`
  );
};

export const updateContractVigency = (
  contractId,
  effectiveFromDate,
  effectiveToDate
) => {
  return api.put(`api/providers/contract/${contractId}/updatecontractvigency`, {
    dateFrom: effectiveFromDate,
    dateTo: effectiveToDate,
  });
};

export const verifyConflict = (companyId, dateFrom, dateTo) => {
  return api.put(`api/providers/contract/verifyvigency`, {
    companyId: companyId,
    dateFrom: dateFrom,
    dateTo: dateTo,
  });
};

export const getMinVigency = (companyId) =>
  api.get(`api/providers/contract/minvigency/${companyId}`);

export const removeContractDocument = (documentId) => {
  return api.delete(`api/providers/contract/documents/${documentId}`);
};

export const getPractitionerTypes = async (specialistId, companyId) => {
  return await api.get(
    `api/providers/specialists/practitionertype/${specialistId}/${companyId}`
  );
};

export const getSpecialist = async (specialistId, fiscalYearId, companyId) => {
  return await api.get(
    `api/providers/specialists/${specialistId}/${fiscalYearId}/${companyId}`
  );
};

export const createSpecialist = async (payload) => {
  return await api.post('api/providers/specialists', payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const updateSpecialist = async (model) => {
  return await api.put('api/providers/specialists', model);
};

export const getSpecialistLicenseDocuments = async (specialistLicenseId) => {
  return await api.get(
    `api/providers/specialists/specialistlicensedocument/${specialistLicenseId}`
  );
};
export const getSpecialistLicenseDocumentTypes = async () => {
  return await api.get(
    `api/providers/specialists/specialistlicensedocumenttypes`
  );
};
export const deleteSpecialistLicenseDocument = async (
  specialistLicenseDocumentId
) => {
  return await api.delete(
    `api/providers/specialists/specialistlicensedocument/${specialistLicenseDocumentId}`
  );
};

export const createDeprExemption = async (payload) => {
  return await api.put('api/providers/specialists/deprexemption', payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const uploadExemptionDocument = async (payload) => {
  return await api.post(
    'api/providers/specialists/deprexemption/uploaddocument',
    payload,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
};

export const createLicense = async (model) => {
  return await api.post('api/providers/specialists/license', model);
};

export const editLicense = async (model) => {
  return await api.put('api/providers/specialists/license', model);
};

export const deleteLicense = async (licenseId) => {
  return await api.delete(`api/providers/specialists/license/${licenseId}`);
};

export const createServicePlace = async (model) => {
  return await api.post('api/providers/specialists/serviceLocation', model);
};

export const editServicePlace = async (model) => {
  return await api.put('api/providers/specialists/serviceLocation', model);
};

export const deleteServicePlace = async (specialistLocationId) => {
  return await api.delete(
    `api/providers/specialists/serviceLocation/${specialistLocationId}`
  );
};

export const getMunicipalityNameByLocationFiscalSpecialist = async (
  locationFiscalSpecialistId
) => {
  return await api.get(
    `/api/providers/specialists/serviceLocation/municipalityName/${locationFiscalSpecialistId}`
  );
};

export const deactivateSpecialist = async (model) => {
  return await api.post('api/providers/specialists/deactivate', model);
};

export const activateSpecialist = async (model) => {
  return await api.post('api/providers/specialists/activate', model);
};

export const hasActiveStudentReferral = async (model) => {
  return await api.get(
    `api/providers/specialists/${model.specialistId}/${model.companyId}/${model.fiscalYearId}/hasactivestudentreferral`
  );
};

export const getAppointmentsCoordinated = async (model) => {
  return await api.get(
    `api/providers/specialists/getappointmentscoordinatedbyspecialist/${model.specialistId}/${model.companyId}`
  );
};

export const getTeacherTapRequest = async (model) => {
  return await api.get(
    `api/providers/specialists/getteachertaprequest/${model.specialistId}/${model.companyId}`
  );
};

export const getReferralForTherapists = async (model) => {
  return await api.get(
    `api/providers/specialists/getreferralfortherapists/${model.specialistId}/${model.companyId}`
  );
};

export const getSpecialistSpecialtyTypes = async () => {
  return await api.get('/api/providers/specialists/specialtyTypes');
};

export const getSupervisedSpecialist = async (
  specialistId,
  supervisedType,
  specialistName,
  ssn,
  fiscalYearId,
  page,
  pageSize,
  companyId
) => {
  return await api.get(`/api/providers/specialists/supervisedspecialist`, {
    params: {
      specialistId: specialistId,
      supervisedType: supervisedType,
      specialistName: specialistName,
      ssn: ssn,
      locationFiscalYearId: fiscalYearId,
      page: page,
      pageSize: pageSize ?? null,
      companyId,
    },
  });
};

export const saveSupervised = async (model) => {
  return await api.post('/api/providers/specialists/savesupervisedinfo', model);
};

export const getSupervisedInfo = async (
  specialistId,
  academicYearId,
  companyId
) => {
  return await api.get(`/api/providers/specialists/supervisedinfo`, {
    params: {
      specialistId: specialistId,
      academicYearId: academicYearId,
      companyId: companyId,
    },
  });
};

export const needToCreateNewExemption = (
  companyId,
  specialistId,
  academicYearId,
  specialistIds
) => {
  let qs = '';

  if (specialistIds != undefined && specialistIds != null) {
    for (let i = 0; i < specialistIds.length; i++) {
      qs += `specialistIds=${specialistIds[i]}&`;
    }
  }

  if (qs.length > 0) qs = qs.slice(0, -1);

  return api.get(
    `/api/providers/specialists/${companyId}/${specialistId}/${academicYearId}/needtocreateexcemption?${qs}`
  );
};

export const getNewExcemptionInfo = (
  companyId,
  specialistId,
  academicYearId,
  exemptionType,
  specialistIds
) => {
  return api.post(
    `/api/providers/specialists/${companyId}/${specialistId}/${academicYearId}/${exemptionType}/getnewexcemptioninfo`,
    specialistIds
  );
};

export const getExistingExcemptionInfo = (exemptionRequestId) => {
  return api.get(`/api/providers/specialists/excemption/${exemptionRequestId}`);
};

export const saveSpecialistExcemption = (payload) => {
  return api.post(
    '/api/providers/specialists/SaveSpecialistExcemption',
    payload,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
    }
  );
};

export const getSpecialistExcemptions = async (
  specialistId,
  companyId,
  academicYearId
) => {
  return await api.get(
    `/api/providers/specialists/${companyId}/${specialistId}/GetSpecialistExcemptions?academicYearId=${academicYearId}`
  );
};

export const getAmendments = (model) => {
  return api.get(
    `api/providers/contract/amendments/${model.contractId}/${model.companyId}/${model.fiscalYearId}`
  );
};

export const insertContractAmendment = (model) => {
  return api.post(`api/providers/contract/amendment`, model);
};

export const updateContractAmendment = (model) => {
  return api.put(`/api/providers/contract/amendment`, model);
};

export const getSpecialtyDisciplines = async (specialtyIds) => {
  return await api.post(
    '/api/providers/specialists/licenses/specialties/disciplines',
    specialtyIds
  );
};

export const isSsnValid = async (ssn) => {
  return await api.post(
    '/api/providers/specialists/validateSsn',
    '"' + ssn + '"'
  );
};

export const getAppointmentFilters = () => {
  return apiMipe.get('api/appointment/initfilters');
};

export const getAppointments = (params) => {
  return apiMipe.get('api/appointment', { params: params });
};

export const changeCenterAppointment = (clientAppointmentId, newCenterId) => {
  return apiMipe.put(
    `api/appointment/coordinatedcenter/${clientAppointmentId}/${newCenterId}`
  );
};

export const changeAppointmentSpecialist = (
  clientAppointmentId,
  specialistLocationId
) => {
  return api.put(
    `api/providers/specialists/appointmentchange/${clientAppointmentId}/${specialistLocationId}`
  );
};

export const getAppointmentHistory = (clientAppointmentId) =>
  apiMipe.get('api/appointment/getappointmenthistory', {
    params: { clientAppointmentId },
  });

export const getReasonsApointmentStatus = (params) => {
  // JSF: isReqNewAppoinment is an optional parameter according to mipe 2 (where this method was migrated from)
  params.isReqNewAppoinment =
    params.isReqNewAppoinment === false ? false : true;

  return apiMipe.get('api/appointment/statusreasons', { params: params });
};

export const getReasonsApointmentStatusDetail = (appointmentStatusReasonCd) => {
  return apiMipe.get(
    `/api/appointment/statusreasondetails/${appointmentStatusReasonCd}`
  );
};

export const cancelAppointment = (params) => {
  return apiMipe.post('api/appointment/cancelappointment', params);
};

export const denyAppointment = (params) => {
  return apiMipe.post('api/appointment/deniedappointment', params);
};

export const getAppointmentInfo = (clientAppointmentId) =>
  apiMipe.get(`api/appointment/getvwclientappointment`, {
    params: {
      clientAppointmentId,
    },
  });

export const getSpecialistPractitioners = (
  disciplineTypeId,
  specialistLocationId
) =>
  apiMipe.get('api/appointment/getspecialistpractitioners', {
    params: {
      disciplineTypeId,
      specialistLocationId,
    },
  });

export const getAppointmentMunicipalities = (
  academicYearId,
  companyId,
  disciplineId,
  serviceId,
  locationAddressMunicipalityId
) =>
  apiMipe.get('api/appointment/getappointmentmunicipality', {
    params: {
      academicYearId,
      companyId,
      disciplineId,
      serviceId,
      locationAddressMunicipalityId,
    },
  });

export const getAppointmentLocations = (
  academicYearId,
  companyId,
  disciplineId,
  serviceId,
  locationAddressMunicipalityId
) =>
  apiMipe.get('api/appointment/getappointmentlocationfiscalyear', {
    params: {
      academicYearId,
      companyId,
      disciplineId,
      serviceId,
      locationAddressMunicipalityId,
    },
  });

export const getAppointmentSpecialists = (
  companyId,
  locationId,
  disciplineId,
  serviceId
) =>
  apiMipe.get('api/appointment/getappointmentspecialists', {
    params: {
      companyId,
      locationId,
      disciplineId,
      serviceId,
    },
  });

export const getAppointmentTherpies = (clientAppointmentId) =>
  apiMipe.get(`api/appointment/getappointmenttherapies`, {
    params: {
      clientAppointmentId,
    },
  });

export const getSpecialistByLocation = (
  academicYearId,
  companyId,
  disciplineId,
  serviceId,
  locationFiscalYearId
) =>
  apiMipe.get('api/appointment/getspecialistbylocation', {
    params: {
      academicYearId,
      companyId,
      disciplineId,
      serviceId,
      locationFiscalYearId,
    },
  });

export const completeAppointment = (params) =>
  apiMipe.post('api/appointment/completeappointment', params);

export const saveStudentEvaluationDocumentRelationship = (params) =>
  apiMipe.post(
    'api/appointment/savestudentevaluationdocumentrelationship',
    params
  );

export const getDispenseAcademicYears = () =>
  apiMipe.get('api/academicyears/dispense');

export const getDispenseStatus = () =>
  api.get('api/dispenseManagement/statuses');

export const getCodeExemptionDeterminationReason = async () =>
  apiMipe.get(`/api/code/exemptiondeterminationreasons`);

export const getSupervisorSpecialist = (params) =>
  api.post(`api/dispenseManagement/supervisorSpecialist`, params);

export const getDispenseProviders = (fiscalYearId) =>
  api.get(`api/dispenseManagement/providers/${fiscalYearId}`);

export const saveSpecialistLetter = (id, educativeRegionId, secretaryName) =>
  api.post(
    `api/dispenseManagement/${id}/savespecialistletter/${educativeRegionId}?secretaryName=${secretaryName}`
  );

export const getDispenses = (
  fiscalYearId,
  monthId,
  year,
  companyId,
  statusId,
  specialistId,
  exemptionTypes,
  pageIndex
) =>
  api.get(`api/dispenseManagement/search`, {
    params: {
      companyId: companyId,
      fiscalYearId: fiscalYearId,
      monthId: monthId,
      statusId: statusId,
      specialistId: specialistId,
      year: year,
      exemptionTypes: exemptionTypes,
      pageIndex: pageIndex,
    },
  });

export const getUmesrAcademicYears = () =>
  apiMipe.get('api/academicyears/umesr');

export const providersAcademicYear = async ({ fiscalYearId }) =>
  await apiMipe.get(`api/provider/${fiscalYearId}`);

export const changeDispenseStatus = (id, payload) =>
  api.put(`/api/dispenseManagement/${id}/changeStatus`, payload);

export const specialistsList = async ({
  fiscalYearId,
  providerId,
  disciplineTypeId,
  validateUserProfile,
  validateLicense,
  locationId,
}) =>
  await api.get('/api/providers/specialists/list', {
    params: {
      fiscalYearId,
      providerId,
      disciplineTypeId,
      validateUserProfile,
      validateLicense,
      locationId,
    },
  });

export const getAcademicYearForDate = async (date) =>
  await apiMipe.get(`/api/academicyears/getacademicyearfordate`, {
    params: { date },
  });

export const getReferralReason = (appointmentId, studentSieId) =>
  api.get(
    `/api/providers/appointmentSpace/referralreason/${appointmentId}/${studentSieId}`
  );

export const getLocations = async (id) =>
  await apiMipe.get(`api/appointment/${id}/location`);

export const saveLocation = (id, parameters) =>
  apiMipe.post(`api/appointment/${id}/location`, parameters);

export const editLocation = (id, parameters) =>
  apiMipe.put(`api/appointment/location/${id}`, parameters);

export const deleteLocation = (id) =>
  apiMipe.delete(`api/appointment/location/${id}`);

export const getRelationships = async (id) =>
  await apiMipe.get(`api/appointment/${id}/relationship`);

export const saveRelationship = (id, parameters) =>
  apiMipe.post(`api/appointment/${id}/relationship`, parameters);

export const editRelationship = (id, parameters) =>
  apiMipe.put(`api/appointment/relationship/${id}`, parameters);

export const deleteRelationship = (id) =>
  apiMipe.delete(`api/appointment/relationship/${id}`);

export const getAllTreatments = (clientAppointmentId) =>
  apiMipe.get(`api/appointment/${clientAppointmentId}/treatment`);

export const addTreatment = (clientAppointmentId, parameters) =>
  apiMipe.post(`api/appointment/${clientAppointmentId}/treatment`, parameters);

export const editTreatment = (treatmentId, parameters) =>
  apiMipe.put(`api/appointment/treatment/${treatmentId}`, parameters);

export const deleteTreatment = (treatmentId) =>
  apiMipe.delete(`api/appointment/treatment/${treatmentId}`);

export const getSpecialistLicenseDisciplines = async (specialistId) =>
  await api.get(
    `api/providers/specialists/${specialistId}/licenses/disciplines`
  );

export const activate = async (id, activationFlag = true) =>
  await api.put(`api/servicelocations/activate/${id}/${activationFlag}`);

export const licenseCanSupervise = async (specialtyId) => {
  return await api.get(
    `/api/providers/specialists/canspecialtysupervise/${specialtyId}`
  );
};

export const getEvaluationDocument = (clientAppointmentId) => {
  return apiMipe.get(`/appointment/documents/${clientAppointmentId}`);
};

export const getDispatchedPOs = (companyId) => {
  return api.get(
    `api/providers/contract/dispatchedpurchaseordernumbers/${companyId}`
  );
};

export const saveContractAmountInformation = (model) => {
  return api.post(`api/providers/contract/purchaseordernumber`, model);
};

export const deleteContractAmountInformation = (model) => {
  return api.put(
    `api/providers/contract/purchaseordernumber/${model.companyContractId}/${model.purchaseOrderNumberId}`
  );
};

export const getDigitNumbers = (poid) => {
  return api.get(
    `api/providers/contract/purchaseordernumber/digitnumbers/${poid}`
  );
};

export const getServicesDiscipline = async (serviceTypeId) => {
  return await api.get(
    `api/providers/specialists/disciplines?serviceTypeId=${serviceTypeId}`
  );
};

export const getContractDocumentTypes = async () => {
  return await api.get(`/api/providers/contract/documenttypes`);
};

export const getProviderProposalInfo = (id) => {
  return api.get(`/api/providers/proposal/providerproposalinfo/${id}`);
};

export const getProviderProposals = (ssn) => {
  return api.get(`/api/providers/proposal/byssn/${ssn}`);
};

export const getProviderProposalValidation = (id) => {
  return api.get(`/api/providers/proposal/validations/${id}`);
};

export const existSSNInRecommendationProposalRequest = (ssn) => {
  return api.get(
    `/api/providers/proposal/existssinrecommendationproposalrequest/${ssn}`
  );
};

export const getSifdeContractInfo = (companyId) => {
  return api.get(`/api/providers/contract/sifdecontractinfo/${companyId}`);
};

export const existsContractForCurrentAcademicYear = (companyId) => {
  return api.get(
    `/api/providers/contract/existscontractforcurrentacademicyear/${companyId}`
  );
};

export const searchContractServices = async (filters) => {
  return await api.get('/api/providers/contract/searchservices', {
    params: filters,
  });
};

export const removeContract = (contractId) =>
  api.delete(`/api/providers/contract/${contractId}`);

export const getAmendmentDocumentTypes = () =>
  api.get('api/providers/contract/amendmentdocumenttype');

export const setAsAttended = async (appointmentId) => {
  apiMipe.put(`api/appointment/setasattendance/${appointmentId}`);
};

export const replaceExemptionDocument = (payload) =>
  api.put(`/api/dispenseManagement/replaceexemptiondocument`, payload);

export const hasDataOnHealthDepartment = async (id, registrationNumber) => {
  return await api.get(
    `api/providers/specialists/hasDataOnHealthDepartment/${id}/${registrationNumber}`
  );
};

export const updateLicenseFromHd = async (registrationNumber) => {
  return await api.put(
    `api/providers/specialists/updateLicenseFromHd/${registrationNumber}`
  );
};

export const deleteTemporalSpecialist = async (id) => {
  return await api.delete(`api/providers/specialists/temporaldata/${id}`);
};

export const getTherapyRooms = async (id) => {
  return await apiMipe.get(`api/tapAlternativeLocations/therapyrooms/${id}`);
};
export const getLevelTypes = () =>
  api.get(`api/providers/specialists/level-types`);
